import script from "./SignUpHomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpHomePage.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpHomePage.vue?vue&type=style&index=0&id=1e0ae5d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0ae5d6"]])

export default __exports__